<template>
      <SubTitle :title-name="sectionName" />

  <v-row class="pa-5 mx-auto" justify="start" align="stretch" style="max-width: 1200px;">
    <v-col
      v-for="card in items"
      :key="card"
      cols="12"
      sm="6"
      md="4"
      align-self="stretch"
      
    >
      <v-card
        class="mx-auto pa-6 card-grid"
        variant="tonal"
        height="100%"
      >
        <template v-slot:title>
          <span class="font-weight-black">{{ card.shop }}</span>
        </template>
        <v-img :src="getImageHero(card.imageUrl)" aspect-ratio="1" contain
          ><template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div> </template
        ></v-img>

        <v-card-text class="bg-surface-light pt-4 flex-grow-1">
         <div v-html="card.content.replace(/<br>/g, '<br />')"></div>
        </v-card-text>


        <v-card-actions class="flex-column justify-center mt-auto" style="min-height: 176px;">
          <v-col v-if="card.linkURL1">
          <v-btn
            variant="outlined"
            class="mx-auto text-capitalize my-2"
            align="center"
            color="primary"
            :href="card.linkURL1"
            target="_blank"
            rel="noopener noreferrer"
            block
            height="72"
          >
            <div class="card-text">通常版</div>
          </v-btn>
          </v-col>
          <v-col v-if="card.linkURL2">
          <v-btn
            variant="outlined"
            class="mx-auto text-capitalize my-2"
            align="center"
            color="primary"
            :href="card.linkURL2"
            target="_blank"
            rel="noopener noreferrer"
            block
            height="72"
          >
            <div class="card-text">限定版</div>
          </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    methods: {
      getImageHero(imagePath) {
        if (!imagePath) {
          return require("@/assets/store_nowprinting.png"); // デフォルト画像を src/assets に配置
        }

        try {
          return require(`@/assets/${imagePath}`); // src/assets 配下の画像を取得
        } catch (e) {
          console.error("画像の取得に失敗しました:", e);
          return require("@/assets/store_nowprinting.png");
        }
      },
    },

    data: () => ({
      sectionName: "店舗特典",
      items: [
        {
          shop: "Amazon様",
          imageUrl: "store_amazon.png",
          linkURL1: "https://amzn.asia/d/0cwGfW22", //通常
          linkURL2: "https://amzn.asia/d/02mNxxE7", //限定
          content: "PC & スマホ オリジナル壁紙",
        },
        {
          shop: "ゲームショップ1983様",
          imageUrl: "store_nowprinting.png",
          linkURL1:"https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=BURAI&FF=0&price_sort=&pic_only=&mode=p_wide&id=42313&superkey=1", //通常
          linkURL2:"https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=BURAI&FF=0&price_sort=&pic_only=&mode=p_wide&id=42314&superkey=1", //通常
          content:
            "■飯島多紀哉氏書き下ろしショートストーリー (アパシー鳴神学園七不思議コラボ)「荒井昭二の異世界探訪」<br>■BURAI人物・事件相関図<br>■MSXタオル",
        },
        {
          shop: "あみあみ様",
          imageUrl: "store_nowprinting.png",
          linkURL1:
            "https://www.amiami.jp/top/detail/detail?gcode=GAME-0033355&_gl=1%2a3h6z2b%2a_ga%2aNTM3NTE1MjI3LjE3NzAxMDc1Mjg.%2a_ga_DNC11S3TQ3%2aczE3NzAxMDc1MjgkbzEkZzEkdDE3NzAxMDc1MzMkajU1JGwwJGgw",
          content: "【あみあみ限定版】通常版 amiamiパック<br>≪amiamiパック特典≫<br>■書き下ろしショートストーリーペーパー",
        },
        {
          shop: "あみあみ様",
          imageUrl: "storeamiami.png",
          linkURL2:"https://www.amiami.jp/top/detail/detail?gcode=GAME-0033356&_gl=1%2ajopsvv%2a_ga%2aNTM3NTE1MjI3LjE3NzAxMDc1Mjg.%2a_ga_DNC11S3TQ3%2aczE3NzAxMDc1MjgkbzEkZzEkdDE3NzAxMDc3MDMkajQ1JGwwJGgw",
          content: "【あみあみ限定版】限定版 amiamiパック<br>≪amiamiパック特典≫<br>■書き下ろしショートストーリーペーパー<br>■ミニアクリルキャラクタープレート(A6サイズ)",
        },
        {
          shop: "famicom shop mario 新橋店様",
          imageUrl: "storemario.png",
          linkURL1:"https://mario484.com/",
          linkURL2:"https://mario484.com/",
          content:
            "飯島多紀哉書き下ろしショートストーリー「新たなるBURAI」",
        },
        {
          shop: "BEEP様",
          imageUrl: "storebeep.png",
          linkURL1:"https://channel.beep-shop.com/products/detail/72283",
          linkURL2:"https://channel.beep-shop.com/products/detail/72284",
          content:
            "飯島多紀哉書き下ろしショートストーリーペーパー「左京編」",
        },
        {
          shop: "ブックオフ様",
          imageUrl: "store_nowprinting.png",
          linkURL1:"https://item-yoyaku.bookoff.co.jp/top",
          content:
            "■クリアしおり<br>■飯島多紀哉書き下ろしオリジナル小説",
        },
      ],

    }),

  };
</script>
<style scoped>
.card-grid {
  display: grid;
  grid-template-rows:
    auto   /* title */
    auto   /* image */
    1fr    /* content（ここだけ伸びる） */
    auto;  /* buttons */
}
</style>